"use client";

import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";

export function RootCanvasController() {
  const pathname = usePathname();

  useLayoutEffect(() => {
    const root = document.documentElement;

    root.toggleAttribute("data-root-canvas-ready", true);
    root.toggleAttribute("data-root-canvas", pathname === "/");

    return () => {
      root.removeAttribute("data-root-canvas");
      root.removeAttribute("data-root-canvas-ready");
    };
  }, [pathname]);

  return null;
}
